import styled from 'styled-components';
import { fonts, media } from '@storefront/lib-global/stylings';

export const Name = styled.h1`
  ${fonts.Montserrat}
  font-size: 20px;
  line-height: 20px;
  margin: 0;

  @media ${media.greaterThan('lg')} {
    font-size: 36px;
    line-height: 36px;
  }
`;

export const ColorName = styled.span`
  display: block;
  ${fonts.Montserrat}
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  margin: 0;

  @media ${media.greaterThan('lg')} {
    font-size: 24px;
    line-height: 28px;
  }
`;
